import { COMMENTS } from '@atlassian/jira-issue-view-common-constants';
import { messages } from './messages';

export const commentActivityItem = {
	key: COMMENTS,
	type: COMMENTS,
	name: messages.comments.defaultMessage,
} as const;
